import { Bell, BellOff, PhoneCall, Video } from "lucide-react";
import { useWhatsAppCall } from "../../context/WhatsAppCallContext";

// Só aparece com o motor Go conectado; no whatsapp-web.js não há ligação.
const WhatsAppCallButton = ({ conversationId }) => {
  const {
    available,
    canMakeCalls,
    canReceiveCalls,
    busy,
    startCall,
    videoSupported,
    quietMode,
    toggleQuietMode,
  } = useWhatsAppCall();

  if (!available) return null;

  const busyTitle = "Já existe uma ligação em andamento";
  const className =
    "rounded-lg bg-green-500 px-4 py-2 text-white transition-colors hover:bg-green-600 disabled:cursor-not-allowed disabled:opacity-50";

  return (
    <>
      {/* Modo silencioso: os avisos de ligação continuam, só sem o toque. */}
      {canReceiveCalls && (
        <button
          onClick={toggleQuietMode}
          title={
            quietMode
              ? "Toque das ligações desligado — clique para ligar"
              : "Toque das ligações ligado — clique para silenciar"
          }
          className={`rounded-lg p-2 transition-colors ${
            quietMode
              ? "bg-yellow-100 text-yellow-700 hover:bg-yellow-200 dark:bg-yellow-900/40 dark:text-yellow-300"
              : "text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700"
          }`}
        >
          {quietMode ? <BellOff className="h-5 w-5" /> : <Bell className="h-5 w-5" />}
        </button>
      )}
      {canMakeCalls && (
        <>
          <button
            onClick={() => startCall(conversationId)}
            disabled={busy}
            title={busy ? busyTitle : "Ligar pelo WhatsApp"}
            className={className}
          >
            <PhoneCall className="mr-2 inline h-4 w-4" />
            Ligar
          </button>
          {videoSupported && (
            <button
              onClick={() => startCall(conversationId, { video: true })}
              disabled={busy}
              title={busy ? busyTitle : "Videochamada pelo WhatsApp"}
              className={className}
            >
              <Video className="mr-2 inline h-4 w-4" />
              Vídeo
            </button>
          )}
        </>
      )}
    </>
  );
};

export default WhatsAppCallButton;
